import React from 'react';

import { useField } from 'app-components/flux/categories/categoryFormHooks';

import Switch from '@mui/material/Switch';

const TaxRelated = () => {
  const { value, onValueChange, onBlur } = useField('taxRelated');

  return (
    <Switch
      checked={!!value}
      onBlur={onBlur}
      onChange={(e, value) => {
        e.stopPropagation();
        onValueChange(value);
      }}
      value={value}
    />
  );
};

export default TaxRelated;
